<template>
    <AdmPanel width="500px" align="center" :loading="loader.detail" :rules="options.validation">
        <h2 slot="header_title">{{ tracker.isNew ? "新建":"编辑" }}指标详情</h2>
        <iv-form :model="sources.detail" label-position="top" :ref="FORM_NAME" :rules="options.validation">
            <!-- <a v-if="!editPublic.is_edit" href="javascript:;" style="position: absolute;z-index: 2;right: 5px;top: 5px;"
              @click="edit">编辑共有属性</a>
            <template v-else>
             <a href="javascript:;" style="position: absolute;z-index: 2;right: 65px;top: 5px;"
               @click="cancelSave">取消</a>
             <a href="javascript:;" style="position: absolute;z-index: 2;right: 5px;top: 5px;"
               @click="savePublic">完成编辑</a>
            </template> -->
            <iv-form-item label="指标编号：" prop="thirdTargetNum">
              <iv-alert>{{ tracker.isNew && $route.params.action != 'baseEdit' ? '保存后系统自动生成':sources.detail.thirdTargetNum }}</iv-alert>
            </iv-form-item>
            <iv-row :gutter="24">
              <iv-col span="16">
                <iv-form-item label="指标名称：" prop="thirdTargetName">
                  <iv-input v-model="sources.detail.thirdTargetName" :placeholder="options.placeholder.thirdTargetName"
                    limiter></iv-input>
                </iv-form-item>
              </iv-col>
              <!-- <iv-col span="8">
                <iv-form-item label="指标单位：" prop="targetUnit">
                  <iv-input :disabled="!editPublic.is_edit" v-model="sources.detail.targetUnit" :placeholder="options.placeholder.targetUnit" limiter></iv-input>
                </iv-form-item>
              </iv-col> -->
            </iv-row>
              <iv-row :gutter="24">
                <iv-col span="16">
                  <iv-form-item label="指标权重：" prop="targetWeight">
                    <iv-input-number :step="0.5" v-model="sources.detail.targetWeight" :placeholder="options.placeholder.targetWeight" style="width:auto;display:block;"></iv-input-number>
                  </iv-form-item>
                </iv-col>
                <iv-col span="8">
                  <iv-form-item label="指标单位：" prop="targetUnit">
                    <iv-input v-model="sources.detail.targetUnit" :placeholder="options.placeholder.targetUnit" limiter></iv-input>
                  </iv-form-item>
                </iv-col>
              </iv-row>
            <iv-form-item label="年份：" prop="year">
              <iv-select :disabled="!tracker.isNew" v-model="sources.detail.year" :placeholder="options.placeholder.year" >
                <template v-for="item in options.year">
                  <iv-option :key="item.id" :value="item.id">{{ item.title }}</iv-option>
                </template>
              </iv-select>
            </iv-form-item>

            <iv-row :gutter="24">
              <iv-col span="12">
                <iv-form-item label="一级指标：" prop="firstTargetNum">
                      <iv-select v-model="sources.detail.firstTargetNum" :placeholder="options.placeholder.firstTargetNum" @on-change="targetChange">
                        <template v-for="item in options.firstTargets">
                          <iv-option :key="item.firstTargetNum" :value="item.firstTargetNum">{{ item.firstTargetName }}</iv-option>
                        </template>
                      </iv-select>
                </iv-form-item>
              </iv-col>
              <iv-col span="12">
                <iv-form-item label="二级指标：" prop="secondTargetNum">
                      <iv-select v-model="sources.detail.secondTargetNum" :placeholder="options.placeholder.secondTargetNum">
                        <template v-for="item in options.secondTargets">
                          <iv-option :key="item.secondTargetNum" :value="item.secondTargetNum">{{ item.secondTargetName }}</iv-option>
                        </template>
                      </iv-select>
                </iv-form-item>
              </iv-col>
            </iv-row>
            <iv-row :gutter="24">
              <!-- <iv-col span="8">
                <iv-form-item label="指标来源：" prop="targetSource">
                  <iv-select v-model="sources.detail.targetSource" :placeholder="options.placeholder.targetSource">
                    <template v-for="item in options.targetSource">
                      <iv-option :key="item.id" :value="item.id">{{ item.title }}</iv-option>
                    </template>
                  </iv-select>
                </iv-form-item>
              </iv-col> -->
              <iv-col span="12">
                <iv-form-item label="指标类型：" prop="targetType">
                  <iv-select v-model="sources.detail.targetType" :placeholder="options.placeholder.targetType" >
                    <template v-for="item in options.targetType">
                      <iv-option :key="item.id" :value="item.id">{{ item.title }}</iv-option>
                    </template>
                  </iv-select>
                </iv-form-item>
              </iv-col>
              <iv-col span="12">
                <iv-form-item label="行业：" prop="industryId">
                  <iv-select :disabled="!tracker.isNew" v-model="sources.detail.industryId"
                    :placeholder="options.placeholder.industryId">
                    <template v-for="item in options.industries">
                      <iv-option :key="item.id" :value="item.id">{{ item.name }}</iv-option>
                    </template>
                  </iv-select>
                </iv-form-item>
              </iv-col>
            </iv-row>
            <iv-form-item label="关键词：" prop="keyword">
              <iv-alert>
                {{ sources.detail.keyword.split('`').join("，") || `请点击右侧编辑录入内容` }}
                <a href="javascript:;"
                  style="position: absolute;z-index: 2;right: 5px;top: 5px;"
                  @click="editModel.keyword = sources.detail.keyword;editModel.show=true">编辑</a>
              </iv-alert>
            </iv-form-item>

            <!-- <hr/>
            <iv-row :gutter="24">
              <iv-col span="8">
                <iv-form-item label="年份：" prop="year">
                  <iv-select :disabled="!tracker.isNew" v-model="sources.detail.year" :placeholder="options.placeholder.year" @on-change="onChangeIndustry">
                    <template v-for="item in options.year">
                      <iv-option :key="item.id" :value="item.id">{{ item.title }}</iv-option>
                    </template>
                  </iv-select>
                </iv-form-item>
               </iv-col>
               <iv-col span="8">
                <iv-form-item label="所属行业：" prop="industryId">
                      <iv-select :disabled="!tracker.isNew" v-model="sources.detail.industryId" :placeholder="options.placeholder.industryId" >
                        <template v-for="item in options.industries">
                          <iv-option :key="item.id" :value="item.id">{{ item.name }}</iv-option>
                        </template>
                      </iv-select>
                </iv-form-item>
               </iv-col>
               <iv-col span="8">
                 <iv-form-item label="指标权重：" prop="targetWeight">
                   <iv-input-number :step="0.5" v-model="sources.detail.targetWeight"
                     :placeholder="options.placeholder.targetWeight" style="width:auto;display:block;">
                   </iv-input-number>
                 </iv-form-item>
               </iv-col>
            </iv-row> -->
            <iv-form-item label="指标评分规则（评分规则修改后需联系系统管理员让规则生效）：" prop="targetRuleExplain">
              <a href="javascript:;" style="position: absolute;z-index: 2;right: 5px;top: -30px;" @click="viewRule">查看其他行业规则</a>
              <iv-row :gutter="24">
                <iv-col span="24"> 
                  <iv-input type="textarea" :rows="8" v-model="sources.detail.targetRuleExplain" :placeholder="options.placeholder.targetRuleExplain" limiter></iv-input>
                </iv-col>
              </iv-row>
            </iv-form-item>
            <iv-form-item label="关联CSR指标（用于CSR指标数据传递到双碳指标）：" prop="relatedCsrTargetNum">
              <iv-select v-model="sources.detail.relatedCsrTargetNum"
                    :placeholder="options.placeholder.relatedCsrTargetNum">
                    <template v-for="item in options.CsrTargets">
                      <iv-option :key="item.secondTargetNum" :value="item.secondTargetNum">{{ item.secondTargetName }}</iv-option>
                    </template>
              </iv-select>
            </iv-form-item>
        </iv-form>
        <div slot="footer">
            <span class="adm-buttons pull-right">
                <iv-button @click="$$back({ name: 'carbon_target' })">取消</iv-button>
                <iv-button type="primary" :disabled="editPublic.is_edit" @click="save">保存</iv-button>
            </span>
        </div>
        <TagsEditModel :item='editModel' @SaveKeyword="SaveKeyword" @shown-changed="editModel.show=$event"></TagsEditModel>
        <!-- 行业规则展示 -->
        <iv-modal
          v-model="RuleModal.visible"
          title="其他行业规则"
          width="600">
          <iv-row :gutter="24" style="margin-bottom: 20px;">
            <iv-col span="16">
              <ThirdTargetSelect filterable clearable transfer v-model="RuleModal.thirdTargetNum" style="width:200px"/>
               <iv-button type="info" @click="getRule()" style="margin-left: 10px;">
                 <iv-icon type="md-search" size="14" style="vertical-align:text-bottom" /> 查询
               </iv-button>
            </iv-col>
          </iv-row>

        <iv-table :columns="RuleModal.columns" :data="RuleModal.list.data" border></iv-table>
        <template v-if="RuleModal.last_page > 1">
        <div style="text-align: end;margin-top: 10px;">
            <iv-page
                    @on-change="pageChanged"
                    :current="RuleModal.current_page"
                    :page-size="RuleModal.limit"
                    show-elevator
                    show-total
                    :total="RuleModal.total">
            </iv-page>
        </div>
        </template>
        <iv-button type="primary" slot="footer" @click="handleCancel">关闭</iv-button>
        </iv-modal>
    </AdmPanel>
</template>

<script>
    import TargetModel from "@/models/TargetModel";
    import CarbonTargetModel from "@/models/CarbonTargetModel";
    import CarbonIndustryModel from "@/models/CarbonIndustryModel";
    import LoaderMixin from "@/mixins/Loader.mixin";
    import DetailMixin from "@/mixins/Detail.mixin";
    import ModelMixin from "@/mixins/Model.mixin";
    import TagsEditModel from '@/components/TagsEditModel'
    import ThirdTargetSelect from '@/components/ThirdTargetSelect'
    import contact from "@/utils/contact";
    import { carbon_years } from "@/utils/"
    import clip from "@/utils/clipboard"
    import { companyType, isDelete, targetType, targetSource, classification } from "@/configs/options.conf"

    const _years = carbon_years().map(year=>({...year, title:year.name}))

    const CSR_TARGET = TargetModel.ModelName;
    const TARGET = CarbonTargetModel.ModelName;
    const INDUSTRY = CarbonIndustryModel.ModelName;
    const FORM_NAME = `${TARGET}Form`;
    const options = {
        companyType,
        isDelete,
        targetType,
        targetSource,
        classification,
        year: _years
    }
    function columns(vm){
      return [
        {
          title: "行业",
          key: "industry",
          align: "center",
          minWidth: 60,
        },
        {
          title: "评分规则",
          key: "targetRuleExplain",
          align: "left",
          minWidth: 250,
        },
        {
          title: "操作",
          align: "center",
          minWidth: 100,
          render(h, params){
          const item = params.row;
          return (
          <adm-link-group>
            <a href="javascript:;" onClick={ (e)=>vm.handleCopy(item.targetRuleExplain, e, '评分规则复制成功') }>复制</a>
          </adm-link-group>
          );
          }
        }
      ]
    }
    export default {
        name: "company_detail",
        mixins: [
            LoaderMixin(TARGET),
            ModelMixin({
                contact,
                models:[
                    TargetModel, CarbonIndustryModel,CarbonTargetModel
                ]
            }),
            DetailMixin({
                model: TARGET,
                form: FORM_NAME,
                schema(data){
                    return data
                }
            })
        ],
        data() {
            return {
                TARGET,
                CSR_TARGET,
                FORM_NAME,
                options: {
                    ...options,
                    industries: [],
                    firstTargets: [],
                    secondTargets:[],
                    thirdTargets:[],
                    CsrTargets:[],
                    validation : TargetModel.validation(),
                    placeholder: {
                        abbreviation: '请输入公司简称',
                        secondTargetNum: '请输入股票代码',
                        companyName: '请输入公司全称',
                        companyType: '请选择上市类型',
                        industryIdList: '请选择公司所在行业',
                        isDelete: '请选择公司状态',
                    },
                },
                editModel:{
                    show        : false,
                    keyword     : ''
                },
                editPublic: {
                  originDetail: {},
                  is_edit: false,
                  tips:''
                },
                RuleModal:{
                  visible:false,
                  columns:columns(this),
                  list:{
                    data:[]
                  },
                  offset:0,
                  current_page:1,
                  last_page:0,
                  total:0,
                  limit:10,
                  thirdTargetNum:[],
                  loading:false,
                }
            }
        },
        async mounted() {
            this.refreshfirstTarget()
            // this.refreshthirdTarget()
            //加载行业
            this.options.industries = await this.refreshIndustries();
        },
        beforeRouteUpdate(to, from, next) {
            this.$nextTick(async () => {
                if (this.options.industries.length == 0) {
                    this.options.industries = await this.refreshIndustries();
                }
            })
        },

        methods: {
            async refreshIndustries(query) {
                const industry = await this.$$fetch(INDUSTRY, query);
                if (industry) return industry.data.map(item => ({ ...item, name: item.industry, title: item.industry }));
            },
            async refreshCompanys(query, industryId) {
                this.$$loading(TARGET);
                const res = await this.$$fetch(TARGET, query);
                this.$$loaded(TARGET);
                return res.data;
            },
            async onChangeIndustry(val){
              this.options.industries = await this.refreshIndustries({year:val})
            },
            async refreshfirstTarget(params = this.$route.params){
                const firstTarget = await this.$$active(TARGET, 'firstTarget',params)
                if(firstTarget)  this.options.firstTargets = firstTarget.data
            },
            async refreshCsrSecondTarget(params = this.$route.params){
                const CsrTarget = await this.$$active(CSR_TARGET, 'secondTarget',params)
                if(CsrTarget) this.options.CsrTargets = CsrTarget.data
            },
            async refreshsecondTarget(params = this.$route.params){
                const secondTarget = await this.$$active(TARGET, 'secondTarget',params)
                if(secondTarget)  this.options.secondTargets = secondTarget.data
            },
            async refreshthirdTarget(params = this.$route.params){
                const thirdTarget = await this.$$active(TARGET, 'thirdTarget',params)
                if(thirdTarget) this.options.thirdTargets = thirdTarget.data
            },
            save(){
                let action = this.$route.params.action ? this.$route.params.action : ''
                this
                    .$$saveDetail({ data: this.sources.detail, action : action})
                    .then((res)=>{
                        if([400,409].indexOf(res.code) > -1 ) this.$$error(new Error(err.response.data.msg), 5)
                        else this.$$back({ name: 'carbon_target' , query: { ...this.$route.query, ordering:
                        '-updateTime'}})
                    });
            },
            destroy(){
                this
                    .$$destroyDetail()
                    .then(()=>this.$$back({ name: TARGET }));
            },
            $$onRefreshDetail(data){
                data = this[`$${TARGET}`].schema.format(data)
                // data.id = data.secondTargetId
                this.editModel.keyword = data.keyword
                return data;
            },
            async $$refreshDetail(query) {
              query = { ...query, ...this.$route.query }
                if (query && query.thirdTargetNum && query.year) {
                    this._continue = true;
                    const result = await this.$$active(TARGET, 'historyTarget', query);
                    const detail = !!result.data.length ? result.data[0] : {}
                    this.tracker.isNew = false;
                    this.sources.detail = await this.$$onRefreshDetail(detail);
                    delete this.sources.detail.industryIdList
                    this.$nextTick(() => {
                        this._continue = false;
                    });
                } else if(query && query.action == 'baseEdit' && query.thirdTargetNum) {
                  this._continue = true;
                    const result = await this.$$active(TARGET, 'historyTarget', query);
                    const detail = !!result.data.length ? result.data[0] : {}
                    this.tracker.isNew = true;
                    this.sources.detail = await this.$$onRefreshDetail(detail);
                    this.sources.detail = {
                      ...this.sources.detail,
                      industryId:null,
                      // year:null,
                      // targetWeight:null,
                      // targetRuleExplain:''
                    }
                    delete this.sources.detail.industryIdList
                    this.$nextTick(() => {
                        this._continue = false;
                  });
                }
                this.RuleModal.thirdTargetNum = [this.sources.detail.thirdTargetNum]
            },
            async SaveKeyword(item){
              this.sources.detail.keyword = this.editModel.keyword = item.keyword
            },
            edit(){
              this.editPublic.is_edit=true;
              const keysToClone = [
                "secondTargetNum",
                "secondTargetName",
                "targetUnit",
                "firstTargetNum",
                "targetSource",
                "targetType",
                "classification",
                "keyword"
              ];
              this.editPublic.originDetail = Object.fromEntries(
                Object.entries(this.sources.detail).filter(([key]) => keysToClone.includes(key))
              );
            },
            savePublic(){
              this.$$success("编辑成功")
              this.editPublic.is_edit=false
            },
            cancelSave(){
              this.sources.detail = Object.assign(this.sources.detail, this.editPublic.originDetail)
              this.editPublic.is_edit=false
              this.editPublic.originDetail = {}
            },
            async viewRule(){
                this.RuleModal = {
                  ...this.RuleModal,
                  list:{},
                  offset:0,
                  current_page:1,
                  last_page:0,
                  total:0,
                  visible : true
                }
                console.log(this.RuleModal.thirdTargetNum,'this.RuleModal.thirdTargetNum')
                if(this.RuleModal.thirdTargetNum.length>0) await this.getRule()
            },
            async getRule(query={
              offset: this.RuleModal.offset, 
              limit: this.RuleModal.limit,
              thirdTargetNum:this.RuleModal.thirdTargetNum.length>0 ? this.RuleModal.thirdTargetNum[0]:'' 
            }){
                console.log(this.RuleModal.thirdTargetNum,'this.RuleModal.thirdTargetNum')
                this.RuleModal.list = await this.$$active(TARGET, 'targetRuleExplain', query);
                this.RuleModal.total = this.RuleModal.list.total
                this.RuleModal.current_page = this.RuleModal.offset ? this.RuleModal.offset / this.RuleModal.limit + 1 : 1
                this.RuleModal.last_page = this.RuleModal.total / this.RuleModal.limit
              },
            async pageChanged(page){
                this.RuleModal.offset = ( page - 1 ) * this.RuleModal.limit
                await this.getRule()
            },
            handleCancel(){
              this.RuleModal.visible=false
            },
            targetChange(item){
              this.refreshsecondTarget({
                year:this.sources.detail.year,
                firstTargetList: this.sources.detail.firstTargetNum ?JSON.stringify([this.sources.detail.firstTargetNum]) : undefined
              })
            },
            handleCopy(text, event, content){
              clip(text, event, content)
            },
            onThirdTargetChange(item){
              console.log(item,'itennnn',this.RuleModal.thirdTargetNum)
            }
        },
        watch: {
          'sources.detail.year'(val){
             this.refreshfirstTarget({
                year:val
              })
              this.refreshsecondTarget({
                year:val,
                firstTargetList: this.sources.detail.firstTargetNum ?JSON.stringify([this.sources.detail.firstTargetNum]) : undefined
              })
              this.refreshCsrSecondTarget({
                year:val
              })
          },
          'sources.detail.firstTargetNum'(val){
            this.refreshsecondTarget({
              year:this.sources.detail.year,
              firstTargetList: val ?JSON.stringify([val]) : undefined
            })
          },
        },
        components: { TagsEditModel, ThirdTargetSelect }
    }
</script>

<style scoped>
  hr{
    margin: 50px 0 20px;
    border: 0;
    height: 1px;
    background-color: lightgray;
  }
</style>
